<!-- 顶栏 -->
<template>
  <header class="app-header">
    <div class="app-nav-logo">
      <img :src="APP_CONFIG.platformLogo" alt="" />
      <span>{{ APP_CONFIG.platformTitle }}</span>
    </div>
    <div class="app-nav-handle">
      <TitleMap />
      <TagsView />
      <div class="app-nav-right">
        <!-- 查询菜单 -->
        <!-- <SearchMenu /> -->
        <!-- 全屏开关 -->
        <!-- <Screenfull /> -->
        <!-- <div class="app-header-icon">
          <svg-icon iconClass="ant-setting"></svg-icon>
        </div> -->

        <el-dropdown trigger="click" @visible-change="handleDropdownVisible">
          <!-- 主头像 -->
          <div class="cursor-pointer" style="display: flex">
            <el-avatar class="cursor-pointer" style="height: 30px;width: 30px;margin-top: 5px" :src="require('@/assets/touxiang.png')"></el-avatar>
            <div class="username_top">{{ userName.realName }}</div>
            <i class="arrow-icon" :class="{'el-icon-arrow-up': isDropdownOpen, 'el-icon-arrow-down': !isDropdownOpen}"></i>
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <!-- 新增带小头像的信息行 -->
              <el-dropdown-item disabled>
                <div class="user-dropdown">
                  <el-avatar :src="require('@/assets/touxiang.png')" style="height: 30px;width: 30px;margin-right: 8px"></el-avatar>
                  <div class="username">{{ userName.realName }}</div>
                </div>
              </el-dropdown-item>
              <el-dropdown-item divided>
                <span style="display: block; padding: 5px" @click="show()">修改密码</span>
              </el-dropdown-item>
              <el-dropdown-item divided>
                <span style="display: block; padding: 5px" @click="logout">退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>

    <el-dialog :close-on-click-modal="false" title="修改密码" append-to-body v-model="dialogVisible" width="30%">
      <el-form ref="form" :model="formData" :rules="formRule" label-width="80px">
        <el-form-item label="原密码" prop="password">
          <el-input
            type="password"
            v-model="formData.password"
            style="width: 300px"
            placeholder="请输入原密码"
            clearable
          />
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input
            type="password"
            v-model="formData.newPassword"
            style="width: 300px"
            placeholder="请输入新密码"
            clearable
          />
        </el-form-item>
      </el-form>
      <template #footer><span class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confim">确 定</el-button>
      </span></template>
    </el-dialog>
  </header>
</template>

<script>
import { changePwd } from '@/api/user'
import { getToken } from '@/utils/auth';
import { TitleMap, Screenfull, SearchMenu, TagsView } from './components';
import MyStorage from '@/utils/cache';

export default {
  name: 'AppHeader',
  components: {
    TitleMap,
    Screenfull,
    SearchMenu,
    TagsView
  },
  data() {
    return {
      isDropdownOpen: false,
      userName: MyStorage.getItem('userInfo'),
      formData: {
        password: '',
        newPassword: ''
      },
      dialogVisible: false,
      formRule: {
        password: [{ required: true, message: '请输入必填项', trigger: 'blur' }]
      }
    };
  },
  computed: {
    APP_CONFIG() {
      return this.$store.getters.config;
    }
  },
  methods: {
    handleDropdownVisible(visible) {
      this.isDropdownOpen = visible;
    },
    logout() {
      this.$confirm('确认退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          await this.$store.dispatch('user/logout');
          location.href = `#/login?redirect=${this.$route.fullPath}`;
        })
        .catch(() => {});
    },
    confim() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let data = {
            password: this.formData.password,
            newPassword: this.formData.newPassword,
            token: getToken()
          };
          changePwd(data).then((res) => {
            if (res.message.code == 0) {
              this.$message.success('修改成功，请重新登录');
              this.logout();
            } else {
              this.$message.error(res.message.message);
            }
          });
        }
      });
    },
    show() {
      this.formData.password = '';
      this.formData.newPassword = '';
      this.dialogVisible = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.app-header {
  @include flexBetweenCenter;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3;
  gap: 15px;
  padding: 0 15px;
  width: 100%;
  height: 64px;

  .app-nav-logo {
    display: flex;
    align-items: center;
    min-width: $-menu-width;
    gap: 5px;
    font-size: 17px;
    font-weight: 500;
    flex-shrink: 0;
    img {
      width: 36px;
      height: auto;
      border-radius: 50%;
    }
  }

  .app-nav-handle {
    @include flexBetweenCenter;
    justify-content: flex-start;
    gap: 15px;
    flex: 1;
    overflow: hidden;
  }
  .app-nav-right {
    @include flexBetweenCenter;
    margin-left: auto;
    flex-shrink: 0;
    gap: 15px;
  }
}
.user-dropdown {
  padding: 5px 0;
  display: flex;
  align-items: center;
  .username {
    font-weight: 500;
    color: black;
    line-height: 40px;
  }
}
.username_top {
  font-weight: 500;
  color: black;
  line-height: 40px;
  margin-left: 8px;
}
.arrow-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-left: 5px;
  transition: transform 0.3s ease;
  font-size: 12px;
  line-height: 40px;
}

.arrow-down {
  transform: rotate(0deg);
  color: black;
}

.arrow-up {
  transform: rotate(180deg);
  color: black;
}
</style>
